import { render, staticRenderFns } from "./AddressBookAddressForm.vue?vue&type=template&id=45329551&scoped=true&"
import script from "./AddressBookAddressForm.vue?vue&type=script&lang=ts&"
export * from "./AddressBookAddressForm.vue?vue&type=script&lang=ts&"
import style0 from "./AddressBookAddressForm.vue?vue&type=style&index=0&id=45329551&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45329551",
  null
  
)

export default component.exports